import './MenuList.scss';

import classNames from 'classnames';
import { useState } from 'react';

const className = 'c-EcommerceMenuList';

type MenuItemProps = {
  item: { value: string; label: string };
  handleItemClick: (item: { value: string; label: string }) => void;
};

type MenuListProps = {
  items: { value: string; label: string }[];
  showList: boolean;
  onItemClick: (item: { value: string; label: string }) => void;
};

export const MenuList = ({ items, showList, onItemClick }: MenuListProps) => {
  return (
    <div
      className={classNames(`${className}__menu-item-children`, {
        [`${className}__menu-item-children__focused`]: showList,
      })}
    >
      {showList && (
        <ul className={`${className}__dropdown`}>
          {items.map((item) => (
            <MenuItem
              key={item.value}
              item={item}
              handleItemClick={onItemClick}
            />
          ))}
        </ul>
      )}
    </div>
  );
};

const MenuItem = ({ item, handleItemClick }: MenuItemProps) => {
  const [isFocused, setIsFocused] = useState<boolean>(false);
  const handleFocus = () => setIsFocused(true);
  const handleBlur = () => {
    setIsFocused(false);
  };

  return (
    <div
      tabIndex={0}
      className={classNames(`${className}__submenu-item`, {
        [`${className}__submenu-item--focused`]: isFocused,
      })}
      onMouseEnter={handleFocus}
      onFocus={handleFocus}
      onMouseLeave={handleBlur}
      onBlur={handleBlur}
      onClick={() => handleItemClick(item)}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          handleItemClick(item);
        }
      }}
    >
      {item.label}
    </div>
  );
};

export default MenuList;
